/* 审核列表 */
<template>
  <div>
    <div class="page_top">
      <div class="title_wrapper">
        <div class="dis_flex">
          <h1 class="title_from">审核管理</h1>
        </div>

      </div>
      <div class="search_wrapper">
        <a-form layout="inline">
          <a-form-item label="审核编号">
            <a-input v-model="queryParam.auditCode" :max-length="25" placeholder="审核编号" allow-clear />
          </a-form-item>
          <a-form-item label="来源类型">
            <a-select class="w80" v-model="queryParam.resourceType">
              <a-select-option value="">全部</a-select-option>
              <a-select-option v-for="(d, index) in resourceTypeOpts" :key="index" :value="d.dictValue" >
                {{ d.dictLabel }}
              </a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item label="审核状态">
            <a-select class="w80" v-model="queryParam.auditStatus">
              <a-select-option value="">全部</a-select-option>
              <a-select-option v-for="(d, index) in auditStatusOpts" :key="index" :value="d.dictValue" >
                {{ d.dictLabel }}
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-form>

        <a-radio-group>
          <a-button class="mr20" type="default" @click="getClearList">
            重置
          </a-button>
          <a-button class="mr20" type="primary" @click="getList">
            <!-- <a-icon type="search" /> -->查询
          </a-button>
        </a-radio-group>
      </div>
    </div>

    <div class="list_wrapper">
      <no-data v-if="total<=0"></no-data>
      <div v-else>
        <a-table
          :loading="loading"
          :columns="columns"
          :data-source="list"
          :pagination="pagination"
          @change="handleChangeInTable"
          :rowKey="
            (item, index) => {
              return index
            }
          "
        >
          <template slot="resourceType.resourceCode.resourceShowName" slot-scope="text, item">
            <a
              v-if="item.resourceType == '1' "
              :href="'#/houses/detail/index?id='+item.resourceId+'&formTitle=房源详情'"
              target="_self"
              :title="'进入'+ item.resourceType | filterDict(resourceTypeOpts) ">
              {{ item.resourceType | filterDict(resourceTypeOpts) }}[{{ item.resourceCode }}][{{ item.resourceShowName }}]
            </a>

            <a
              v-if="item.resourceType == '2' "
              :href="'#/tourist/details?id='+item.resourceId"
              target="_self"
              :title="'进入'+item.resourceType | filterDict(resourceTypeOpts)">
              {{ item.resourceType | filterDict(resourceTypeOpts) }}[{{ item.resourceCode }}][{{ item.resourceShowName }}]
            </a>

            <a
              v-if="item.resourceType == '3' "
              :href="'#/contract/details?id='+item.resourceId"
              target="_self"
              :title="'进入'+item.resourceType | filterDict(resourceTypeOpts)">
              {{ item.resourceType | filterDict(resourceTypeOpts) }}[{{ item.resourceCode }}][{{ item.resourceShowName }}]
            </a>
          </template>
          <template slot="auditStatus" slot-scope="text, item">
            <span style="color:orange" v-if="item.auditStatus == 1 || item.auditStatus == 2 " class="item_con_val">{{ item.auditStatus | filterDict(auditStatusOpts) }}</span>
            <span style="color:green" v-if="item.auditStatus == 3 " class="item_con_val">{{ item.auditStatus | filterDict(auditStatusOpts) }}</span>
            <span style="color:red" v-if="item.auditStatus == 4 || item.auditStatus == 5 " class="item_con_val">{{ item.auditStatus | filterDict(auditStatusOpts) }}</span>
          </template>

          <template slot="operation" slot-scope="text, item">
            <a-button-group>
              <a-button class="" type="link" @click="detailHandle(item)">
                详情
              </a-button>
              <a-button v-if="item.auditStatus == 1 " class="" type="link" @click="auditingHandle(item)">
                审核
              </a-button>
              <a-button v-else disabled class="" type="link" @click="auditingHandle(item)">
                审核
              </a-button>
            </a-button-group>
          </template>

        </a-table>

      </div>

      <!-- 审核弹出框 -->
      <!--  <div v-if="optPage== 'audit'" > -->
      <a-modal v-model=" showAuditModal" :title="modalTitle" @ok="handleOk" ok-text="提交" cancel-text="取消">
        <div class="resource_info">
          <div class="item_con" v-if="curResourceType == 1 || curResourceType == 2">
            <span class="item_con_name">认领理由：</span>
            <span class="item_con_val">{{ dataInfo.receiveRemark }}</span>
          </div>
          <div v-if="curResourceType == 3">
            <h1>{{ contractsObj.contractCode }}</h1>
            <p class="price">{{ contractsObj.rentExpense }}元/月</p>
            <p>
              {{ contractsObj.paymentMethod }}|免租期{{ contractsObj.rentfreePeriod }}天|转让费
              {{ contractsObj.transferFee }}万元|{{ contractsObj.growthPattern }}
            </p>
            <p>
              租期{{ $moment(contractsObj.leaseStartTime).format('YYYY年MM月DD日') }}
              -
              {{ $moment(contractsObj.leaseEndTime).format('YYYY年MM月DD日') }}
            </p>
            <p class="remarks">
              {{ contractsObj.contractsRemark ? contractsObj.contractsRemark : '暂无备注' }}
            </p>
          </div>
        </div>
        <a-form-model ref="submitInfo" :model="submitInfo" :rules="rules" >
          <a-form-model-item colon label="备注" prop="auditRemark" >
            <a-textarea v-model="submitInfo.auditRemark" :max-length="200" placeholder="请输入您的备注信息" :rows="4" allow-clear/>
          </a-form-model-item>

          <a-form-model-item colon label="审核结果" prop="auditStatus" >
            <a-radio-group v-model="submitInfo.auditStatus" @change="auditStatusChange">
              <a-radio value="3">审核通过</a-radio>
              <a-radio value="4">驳回</a-radio>
            </a-radio-group>
          </a-form-model-item>
        </a-form-model>
      </a-modal>
      <!--  </div>

            <div v-else class="resource_info"> -->
      <a-modal
        v-model="showDetailModal"
        :title="modalTitle"
        :footer="footer"
        @ok="handleOk"
        ok-text="提交"
        cancel-text="取消">
        <div class="item_con" v-if="curResourceType == 1 || curResourceType == 2">
          <span class="item_con_name">认领理由：</span>
          <span class="item_con_val">{{ dataInfo.receiveRemark }}</span>
        </div>
        <div v-if="curResourceType == 3">
          <h1 class="code_cls">{{ contractsObj.contractCode }}</h1>
          <p class="price">{{ contractsObj.rentExpense }}元/月</p>
          <p>
            {{ contractsObj.paymentMethod }}|免租期{{ contractsObj.rentfreePeriod }}天|转让费
            {{ contractsObj.transferFee }}万元|{{ contractsObj.growthPattern }}
          </p>
          <p>
            租期{{ $moment(contractsObj.leaseStartTime).format('YYYY年MM月DD日') }}
            -
            {{ $moment(contractsObj.leaseEndTime).format('YYYY年MM月DD日') }}
          </p>
          <p class="remarks">
            {{ contractsObj.contractsRemark ? contractsObj.contractsRemark : '暂无备注' }}
          </p>
        </div>
        <div >
          <div class="item_con">
            <span class="item_con_name">备注信息：</span>
            <span class="item_con_val">{{ submitInfo.auditRemark != ''&&submitInfo.auditRemark != null ? submitInfo.auditRemark :'暂无' }}</span>
          </div>
          <div class="item_con">
            <span class="item_con_name">审核状态：</span>
            <span style="color:orange" v-if="submitInfo.auditStatus == 1 || submitInfo.auditStatus == 2 " class="item_con_val">{{ submitInfo.auditStatus | filterDict(auditStatusOpts) }}</span>
            <span style="color:green" v-if="submitInfo.auditStatus == 3 " class="item_con_val">{{ submitInfo.auditStatus | filterDict(auditStatusOpts) }}</span>
            <span style="color:red" v-if="submitInfo.auditStatus == 4 || submitInfo.auditStatus == 5 " class="item_con_val">{{ submitInfo.auditStatus | filterDict(auditStatusOpts) }}</span>
          </div>
        </div>
      </a-modal>
    <!-- </div> -->

    </div>
  </div>
</template>

<script>
import { auditRecordList, auditingDetail, editAuditRecord,
//  houseInfo, lesseeInfo,
 contractsInfo } from '@/api/auditing/auditing'

const columns = [
  {
    title: '序号',
    align: 'center',
    width: 70,
    customRender: (text, record, index) => `${index + 1}`
  },
  {
    title: '审核编号',
    dataIndex: 'auditCode',
    key: '2',
    width: 125,
    scopedSlots: { customRender: 'auditCode' }
  },
  {
    width: 210,
    title: '来源类型【编号】【名称】',
    dataIndex: 'resourceType.resourceCode.resourceShowName',
    key: '3',
    ellipsis: false,
    scopedSlots: { customRender: 'resourceType.resourceCode.resourceShowName' }
  },
  {
    align: 'center',
    title: '状态',
    dataIndex: 'auditStatus',
    key: '4',
    ellipsis: true,
    scopedSlots: { customRender: 'auditStatus' }
  },
  {
    align: 'center',
    title: '创建人',
    dataIndex: 'createBy',
    key: '5',
    ellipsis: true,
    scopedSlots: { customRender: 'createBy' }
  },
   {
    align: 'center',
    title: '审核人',
    dataIndex: 'auditUserName',
    key: '6',
    ellipsis: true,
    scopedSlots: { customRender: 'auditUserName' }
  },
   {
    width: 165,
    align: 'center',
    title: '审核时间',
    dataIndex: 'auditTime',
    key: '7',
    ellipsis: true,
    scopedSlots: { customRender: 'auditTime' }
  },
  {
    title: '操作',
    align: 'center',
    dataIndex: 'operation',
    key: '8',
    ellipsis: false,
    scopedSlots: { customRender: 'operation' }
  }
]
export default {
  name: 'Auditing',
  props: { },
  components: {
  },
  data () {
    return {
      // 分页参数
      pagination: {
        current: 1,
        pageSize: this.$getters.pageSize,
        pageSizeOptions: ['10', '20', '30'],
        showTotal: (total, range) => {
          // range[0] + '-' + range[1] +
          return ' 共' + total + '条'
        },
        showQuickJumper: true,
        showSizeChanger: true,
        total: 0
      },
        modalTitle: '',
        modalVisible: false,
        loading: false,
        list: [],
        showAuditModal: false,
        showDetailModal: false,
        total: 0,
        footer: '',
        showFooter: true,
        // 来源类型 字典表类型：resource_type
        resourceTypeOpts: [],
        // 审核状态 字典表类型：audit_status
        auditStatusOpts: [],
        queryParam: {
            pageNum: 1, //	当前页数	query	true
            pageSize: this.$getters.pageSize, //	分页大小	query	true
            resourceType: undefined, //	来源类型 字典表类型：resource_type	query	false
            auditStatus: undefined, //	审核状态 字典表类型：audit_status	query
            isAsc: undefined, //	排序的方向	query	false
            orderByColumn: undefined, //	排序列	query	false
            auditCode: undefined, // 审核编号
            userId: undefined // 用户ID
        },
        columns,
        dataInfo: {
            createdBy: undefined,
            resourceShowName: undefined,
            auditCode: undefined, //	审核编号	string
            auditRemark: undefined, //	备注	string
            auditStatus: undefined, //	审核状态 字典表类型：audit_status	string
            auditTime: undefined, //	审核时间	string(date-time)

            auditUserName: undefined, //	审核人名称	string
            createTime: undefined, //	创建时间	string(date-time)
            id: undefined, //	id	integer(int64)
            receiveRemark: undefined, //	认领理由	string
            resourceId: undefined, //	来源ID	integer(int64)
            resourceType: undefined //	来源类型 字典表类型：resource_type	string
        },
        submitInfo: {
            id: undefined, //	id	integer(int64)
            auditStatus: undefined, //	来源类型 字典表类型：resource_type	string
            auditRemark: undefined //	备注	string
        },
        rules: {
            id: [{ required: true, message: '必填', trigger: 'blur' }],
            auditStatus: [{ required: true, message: '必选', trigger: 'blur' }]
        },
        houseObj: {}, // 房源
        lesseeObj: {}, // 客源
        contractsObj: {}, // 合同
        optPage: '', // detail详情、audit审核
        curResourceType: ''
    }
  },
  created () {
      this.initDict()
      this.getClearList()
  },
  computed: {
  },
  watch: {
  },
  methods: {
      initDict () {
        // 审核来源类型 字典表类型：resource_type
        this.getDicts('resource_type').then(response => {
            this.resourceTypeOpts = response.data
        })
        // 审核状态 字典表类型：audit_status
         this.getDicts('audit_status').then(response => {
            this.auditStatusOpts = response.data
        })
      },
      // 分页、排序、筛选变化时触发
    handleChangeInTable (pagination, filters, sorter) {
      this.pagination = pagination
      this.getList()
    },
      auditStatusChange (e) {
        //   console.log(e);
        console.log(e.target.value)
          this.submitInfo.auditStatus = e.target.value
      },
      getClearList () {
        this.queryParam = {
            pageNum: 1, //	当前页数	query	true
            pageSize: this.$getters.pageSize, //	分页大小	query	true
            resourceType: undefined, //	审核来源类型 字典表类型：resource_type	query	false
            auditStatus: undefined, //	审核状态 字典表类型：audit_status	query
            isAsc: undefined, //	排序的方向	query	false
            orderByColumn: undefined, //	排序列	query	false
            auditCode: undefined, // 审核编号
            userId: undefined // 用户ID
        }
        this.getList()
      },
      getList () {
          this.loading = true
          this.queryParam.pageNum = this.pagination.current
          this.queryParam.pageSize = this.pagination.pageSize
          auditRecordList(this.queryParam).then(response => {
              console.log(response)
              if (response.code === 200) {
                  const data = response.data
                  this.list = data.records
                  this.pagination.total = data.total
                  this.total = data.total
              }
            this.loading = false
          })
      },

      // 分页
      onShowSizeChange (current, pageSize) {
        this.queryParam.pageSize = pageSize
        this.getList()
      },
      changeSize (current, pageSize) {
        this.queryParam.pageNum = current
        this.queryParam.pageSize = pageSize
        this.getList()
      },
      // 弹窗
      handleOk (e) {
        this.loading = true
        this.$refs.submitInfo.validate(valid => {
            if (valid) {
                editAuditRecord(this.submitInfo).then(response => {
                    console.log('===审核成功')
                    this.$message.success('审核成功', 3)
                    this.modalVisible = false
                    this.showAuditModal = false
                    this.showDetailModal = false

                    this.getList()
                }).finally(() => {
                this.loading = false
                })
            } else {
                console.log('error')
                return false
            }
        })
      },
      handleCancel (e) {
        this.modalVisible = false
        this.showAuditModal = false
        this.showDetailModal = false
      },

      detailHandle (obj) {
          const id = obj.id
          this.modalTitle = '审核编号【' + obj.auditCode + '】'
          this.modalVisible = true
          // this.showDetailModal=true
          this.footer = null
          this.showFooter = false
          this.getDetailFn(id, 'detail')
      },
      auditingHandle (obj) {
          const id = obj.id

          this.modalTitle = '审核编号【' + obj.auditCode + '】'
          this.modalVisible = true
         // this.showAuditModal=true
          this.footer = ''
          this.showFooter = true
          this.getDetailFn(id, 'audit')
      },
      getDetailFn (id, type) {
          this.loading = true
          auditingDetail(id).then(response => {
              if (response.code === 200) {
                  const obj = response.data
                  this.dataInfo = obj
                  //   1 房源 2客源 3合同
                  const resourceType = obj.resourceType
                  const resourceIdStr = obj.resourceId
                  const resourceId = parseInt(resourceIdStr)

                  this.submitInfo.id = obj.id
                  this.submitInfo.auditStatus = obj.auditStatus
                  this.submitInfo.auditRemark = obj.auditRemark

                  this.optPage = type
                  this.curResourceType = resourceType //   1 房源 2客源 3合同
                  if (parseInt(resourceType) === 1) { // 房源信息
                  } else if (parseInt(resourceType) === 2) { // 客源信息
                  } else if (parseInt(resourceType) === 3) { // 合同信息
                    contractsInfo(resourceId).then(response => {
                        if (response.code === 200) {
                            this.contractsObj = response.data
                        }
                    })
                  }
                  if (type === 'detail') {
                    this.showDetailModal = true
                  } else {
                    this.showAuditModal = true
                  }
                   this.loading = false
              } else {
                   this.loading = false
              }
          })
      }
  },
  filters: {
  }
}
</script>
<style lang="less" scoped>
@titleFontSize:20px;
@titleColor:#222;
@bodyFont:14px;
@bodyColor:#666;
@tagFont:12px;
@tagColor:#ddd;
.w80{
    width:80px;
}
.mr20{
    margin-right:20px;
}
.page_top,
.list_wrapper{
  background:#fff;
  padding:20px;
}
.list_wrapper{
  margin-top:10px;
}
.pagination_wrapper{
    width:100%;
    height:60px
}
.title_wrapper{
    display:flex;
    flex-wrap: wrap;
    width:100%;
    height:auto;
    justify-content: space-between;
}
.title_from{
    font-size:@titleFontSize;
    color:@titleColor;
    font-weight: bolder;
}
.search_wrapper{
    display:flex;
    flex-wrap: wrap;
    width:100%;
    height:auto;
    justify-content: flex-start;
    align-items: center;
    margin-top:30px;
}
.list_wrapper{
    width:100%;
    height:auto;
    .tb_list{
        width:100%;
        tr{
            th,td{
                padding: 12px 8px;
                text-align:center;
                width:10%;
            }
            th{
                font-weight: 500;
                color:rgba(0, 0, 0, 0.85);
                background: #fafafa;
                border-bottom: 1px solid #e8e8e8;
                transition: background 0.3s ease;
            }
            th:nth-child(1){
                width:5%;
            }
            td:nth-child(1){
                width:5%;
            }
            th:nth-child(3){
                width:15%;
            }
            td:nth-child(3){
                width:15%;
            }

            th:nth-child(7){
                width:15%;
            }
            td:nth-child(7){
                width:15%;
            }
            th:nth-child(8){
                width:15%;
            }
            td:nth-child(8){
                width:15%;
            }
        }
        tr:hover{
             background: var(--RowHoverColor);
        }

    }
}
.code_cls{
    font-size: @bodyFont;
}
.item_con{
    width:100%;
    height:auto;
    display:flex;
    align-items: flex-start;
    line-height:45px;
    .item_con_name{
        font-weight: bold;
        color:@bodyColor;
    }
    .item_con_val{
        color:@bodyColor;
    }
}

</style>
